import React, { useState } from "react";
import axios from "axios";
import { message } from "antd";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import SignupBanner from "../images/banners/same.jpg"; // ✅ Import the banner image

function SignupPage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  // ✅ Handle Input Changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Validation
    if (!formData.firstName || !formData.lastName || !formData.phoneNumber || !formData.email || !formData.password || !formData.confirmPassword) {
      message.error("All fields are required.");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post("http://93.127.203.113:5005/passengers", {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        password: formData.password,
      });

      message.success("Signup successful!");
      console.log("Passenger Created:", response.data);

      // Reset form fields
      setFormData({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        password: "",
        confirmPassword: "",
      });

    } catch (error) {
      message.error(error.response?.data?.msg || "Signup failed. Try again.");
    }
  };

  return (
    <>
      <section className="signup-page">
        <HeroPages name="Sign Up" />
        <div className="container">
          <div className="signup-main">
            {/* Left Section: Signup Intro Image */}
            <div className="signup-main__img-wrapper">
              <img className="signup-main__img" src={SignupBanner} alt="signup-section" />
            </div>

            {/* Right Section: Signup Form */}
            <div className="signup-main__text">
              <h2 className="signup-main__title">Join Our Platform</h2>
              <h3 className="signup-main__subtitle">Create an account to get started</h3>
      
              <form onSubmit={handleSubmit} className="signup-form">
                <label>First Name <b>*</b></label>
                <input type="text" name="firstName" placeholder="John" value={formData.firstName} onChange={handleChange} />

                <label>Last Name <b>*</b></label>
                <input type="text" name="lastName" placeholder="Doe" value={formData.lastName} onChange={handleChange} />

                <label>Phone Number <b>*</b></label>
                <input type="tel" name="phoneNumber" placeholder="e.g. 0912345678" value={formData.phoneNumber} onChange={handleChange} />

                <label>Email <b>*</b></label>
                <input type="email" name="email" placeholder="youremail@example.com" value={formData.email} onChange={handleChange} />

                <label>Password <b>*</b></label>
                <input type="password" name="password" placeholder="Create a password" value={formData.password} onChange={handleChange} />

                <label>Confirm Password <b>*</b></label>
                <input type="password" name="confirmPassword" placeholder="Confirm your password" value={formData.confirmPassword} onChange={handleChange} />

                <button type="submit">
                  <i className="fa-solid fa-user-plus"></i>&nbsp; Sign Up
                </button>
              </form>
            </div>
          </div>
        </div>

        <Footer />

        {/* 🌟 Styles for Consistency */}
        <style jsx>{`
          .signup-page {
            width: 100%;
            padding: 80px 20px;
            background-color: #f8f9fa;
          }

          .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
          }

          .signup-main {
            display: flex;
            gap: 40px;
            align-items: center;
            justify-content: center;
          }

          .signup-main__img-wrapper {
            width: 45%;
            border-radius: 10px;
            overflow: hidden;
          }

          .signup-main__img {
            width: 100%;
            height: auto;
            border-radius: 10px;
          }

          .signup-main__text {
            width: 50%;
            background: white;
            padding: 30px;
            border-radius: 12px;
            box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
          }

          .signup-main__subtitle {
            font-size: 1.8rem;
            color: #0c8c49;
            text-transform: uppercase;
            letter-spacing: 2px;
            margin-bottom: 10px;
          }

          .signup-main__title {
            font-size: 3rem;
            color: #333;
            margin-bottom: 15px;
          }

          .signup-form {
            display: flex;
            flex-direction: column;
          }

          .signup-form label {
            font-size: 14px;
            font-weight: bold;
            color: #333;
            margin-bottom: 5px;
          }

          .signup-form input {
            width: 100%;
            padding: 12px;
            font-size: 14px;
            border: 2px solid #ddd;
            border-radius: 8px;
            margin-bottom: 15px;
            transition: border 0.3s;
          }

          .signup-form input:focus {
            border-color: #0c8c49;
            outline: none;
          }

          .signup-form button {
            width: 100%;
            padding: 12px;
            font-size: 16px;
            font-weight: bold;
            color: white;
            background-color: #0c8c49;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            transition: background 0.3s;
          }

          .signup-form button:hover {
            background-color: #09733a;
          }

          @media (max-width: 1024px) {
            .signup-main {
              flex-direction: column;
              text-align: center;
            }

            .signup-main__img-wrapper {
              width: 80%;
            }

            .signup-main__text {
              width: 80%;
            }
          }

          @media (max-width: 768px) {
            .signup-main__title {
              font-size: 2.5rem;
            }

            .signup-form input {
              font-size: 1.5rem;
            }
          }
        `}</style>
      </section>
    </>
  );
}

export default SignupPage;
